import { AfterContentInit, Component, Inject, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { NgModel, UntypedFormControl, Validators } from '@angular/forms';
import { User } from 'src/app/domain/user';
import { UserService } from 'src/app/services/user.service';
import { StringTool } from '../../mapping/string.tool';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-user-box',
    templateUrl: './user-box.component.html',
    styleUrls: ['./user-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserBoxComponent implements OnInit, AfterContentInit {
    @ViewChild('email') emailInput: NgModel;
    readonly EmailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    Model: User = new User();
    IsCreation: boolean = true;

    get IsEmailValid(): boolean {
        return new RegExp(this.EmailPattern).test(this.Model.Email ?? '');
    }

    constructor(
        public dialogRef: MatDialogRef<UserBoxComponent>,
        private userService: UserService,
        @Inject(MAT_DIALOG_DATA) public data) {
        if (data) {
            this.Model = Object.assign({}, data);
            this.IsCreation = false;
        }
    }

    ngOnInit(): void {
    }

    ngAfterContentInit(): void {
       
    }

    CanSave() {
        return StringTool.isNotNullOrEmpty(this.Model.FirstName)
            && StringTool.isNotNullOrEmpty(this.Model.LastName)
            && StringTool.isNotNullOrEmpty(this.Model.Phone)
            && StringTool.isNotNullOrEmpty(this.Model.Email)
            && this.IsEmailValid
            && (!this.IsCreation || (this.emailInput !== undefined && this.emailInput.valid));
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        if (this.CanSave())
            this.dialogRef.close(this.Model);

    }

    public compareUserWith(m1: User, m2: User) {
        return m1 && m2 ? m1.Email === m2.Email : m1 === m2;
    }
}
